"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensionFromFileName = void 0;
const dimensionFromFileName = (url) => {
    const dimensionRegex = /_w(\d+)_h(\d+)/;
    const match = url.match(dimensionRegex);
    if (match && match.length === 3) {
        const width = parseInt(match[1], 10);
        const height = parseInt(match[2], 10);
        if (!isNaN(width) && !isNaN(height))
            return { width, height };
    }
};
exports.dimensionFromFileName = dimensionFromFileName;
